/* (c) Copyright Frontify Ltd., all rights reserved. */

/**
 * @deprecated Use `Dropdown` from `@frontify/fondue/components` instead. Also check {@link https://github.com/Frontify/fondue/blob/main/packages/components/MIGRATING.md#dropdown the migration guide}.
 */
export enum MenuItemStyle {
    Primary = 'Primary',
    Danger = 'Danger',
    Warning = 'Warning',
}

/**
 * @deprecated Use `Dropdown` from `@frontify/fondue/components` instead. Also check {@link https://github.com/Frontify/fondue/blob/main/packages/components/MIGRATING.md#dropdown the migration guide}.
 */
export enum SelectionIndicatorIcon {
    Check = 'Check',
    CaretRight = 'CaretRight',
    None = 'None',
}

/**
 * @deprecated Use `Dropdown` from `@frontify/fondue/components` instead. Also check {@link https://github.com/Frontify/fondue/blob/main/packages/components/MIGRATING.md#dropdown the migration guide}.
 */
export enum MenuItemContentSize {
    XSmall = 'XSmall',
    Small = 'Small',
    Large = 'Large',
}
